import { render } from "./AgencyCampaignsDetails.vue?vue&type=template&id=c0a177f0&scoped=true"
import script from "./AgencyCampaignsDetails.vue?vue&type=script&lang=js"
export * from "./AgencyCampaignsDetails.vue?vue&type=script&lang=js"

import "./AgencyCampaignsDetails.vue?vue&type=style&index=0&id=c0a177f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a177f0"]])

export default __exports__